import React from 'react';
import { CountsData } from '../types';

interface CountsDisplayProps {
  data: CountsData | null;
}

const CountsDisplay: React.FC<CountsDisplayProps> = ({ data }) => {
  console.log('🔍 CountsDisplay - Received data:', data);
  if (!data) return null;

  return (
    <div className="font-mono text-xs">
      <div className="bg-gray-50 p-2 rounded border space-y-1">
        <div className="flex justify-between">
          <span>Invoices:</span>
          <span className="font-semibold">{data.totalInvoices || 0}</span>
        </div>
        <div className="flex justify-between">
          <span>Payments:</span>
          <span className="font-semibold">{data.totalPayments || 0}</span>
        </div>
        <div className="flex justify-between">
          <span>Customers:</span>
          <span className="font-semibold">{data.totalCustomers || 0}</span>
        </div>
      </div>
    </div>
  );
};

export default CountsDisplay;
